const PENDING_KEY = "nomio_pending_verification";
const RESEND_KEY = "nomio_verify_resend_until";

/** How long a pending verification stays valid after page reload (ms). */
const PENDING_TTL_MS = 60 * 60 * 1000; // 1 hour

function safeLocalStorage() {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      return window.localStorage;
    }
  } catch (e) {
    // localStorage may be blocked (Safari private mode, etc.)
  }
  return null;
}

export function readPendingVerification() {
  const ls = safeLocalStorage();
  if (!ls) return null;
  try {
    const raw = ls.getItem(PENDING_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data.email !== "string") return null;
    if (typeof data.savedAt === "number" && Date.now() - data.savedAt > PENDING_TTL_MS) {
      ls.removeItem(PENDING_KEY);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
}

export function writePendingVerification(email) {
  const ls = safeLocalStorage();
  if (!ls || !email) return;
  try {
    ls.setItem(
      PENDING_KEY,
      JSON.stringify({ email, savedAt: Date.now() }),
    );
  } catch (e) {
    /* ignore */
  }
}

export function clearPendingVerification() {
  const ls = safeLocalStorage();
  if (!ls) return;
  try {
    ls.removeItem(PENDING_KEY);
    ls.removeItem(RESEND_KEY);
  } catch (e) {
    /* ignore */
  }
}

export function readResendUntil() {
  const ls = safeLocalStorage();
  if (!ls) return 0;
  try {
    const raw = ls.getItem(RESEND_KEY);
    const num = raw ? Number(raw) : 0;
    return Number.isFinite(num) ? num : 0;
  } catch (e) {
    return 0;
  }
}

export function writeResendUntil(timestampMs) {
  const ls = safeLocalStorage();
  if (!ls) return;
  try {
    ls.setItem(RESEND_KEY, String(timestampMs));
  } catch (e) {
    /* ignore */
  }
}
